var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M160 128.4L192.3 96 352 256 192.3 416 160 383.6 287.3 256z"}));
}

IconArrowRight.displayName = "IconArrowRight";

IconArrowRight.defaultProps = {"height":"16","viewBox":"0 0 512 512","width":"16"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
